// extracted by mini-css-extract-plugin
export default {"container":"BankVerifiedPayBillScreen_container__8afz5","billAmount":"BankVerifiedPayBillScreen_billAmount__xMhIA"};